/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Business days past the earliest transit day the carrier themselves
 * quoted. Zero means they hit their own earliest day; negative means they
 * beat it. The average hides the tail, which is the part a customer
 * remembers, so the percentiles are shown next to it.
 *
 * @export
 * @interface PerformanceTransitSpread
 */
export interface PerformanceTransitSpread {
  /**
   * Delivered shipments with both a quoted window and an actual transit time.
   * @type {number}
   * @memberof PerformanceTransitSpread
   */
  shipments: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceTransitSpread
   */
  average?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceTransitSpread
   */
  p50?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceTransitSpread
   */
  p90?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceTransitSpread
   */
  p99?: number;
}

/**
 * Check if a given object implements the PerformanceTransitSpread interface.
 */
export function instanceOfPerformanceTransitSpread(
  value: object,
): value is PerformanceTransitSpread {
  if (!("shipments" in value) || value["shipments"] === undefined) return false;
  return true;
}

export function PerformanceTransitSpreadFromJSON(
  json: any,
): PerformanceTransitSpread {
  return PerformanceTransitSpreadFromJSONTyped(json, false);
}

export function PerformanceTransitSpreadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceTransitSpread {
  if (json == null) {
    return json;
  }
  return {
    shipments: json["shipments"],
    average: json["average"] == null ? undefined : json["average"],
    p50: json["p50"] == null ? undefined : json["p50"],
    p90: json["p90"] == null ? undefined : json["p90"],
    p99: json["p99"] == null ? undefined : json["p99"],
  };
}

export function PerformanceTransitSpreadToJSON(
  json: any,
): PerformanceTransitSpread {
  return PerformanceTransitSpreadToJSONTyped(json, false);
}

export function PerformanceTransitSpreadToJSONTyped(
  value?: PerformanceTransitSpread | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipments: value["shipments"],
    average: value["average"],
    p50: value["p50"],
    p90: value["p90"],
    p99: value["p99"],
  };
}
